"use client";

import { useEffect } from "react";
import Script from "next/script";
import config from "@/app.config";
import { login } from "@/actions/auth.action";
import axios from "axios";
import { useRouter } from "next/navigation";
import useToast from "@/stores/toast";

export default function GoogleOneTap() {
  const router = useRouter();
  const { toast } = useToast();

  const handleCredentialResponse = async (data: GoogleCredentialResponse) => {
    try {
      const response = await fetch("/api/auth/google", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token: data.credential }),
      });

      const {
        data: { name, email },
      } = await response.json();

      const res = await axios.post(
        `${config.app.apiBaseUrl}/api/v2/socialite`,
        {
          first_name: name.split(" ")[0] ?? "",
          last_name: name.split(" ")[1] ?? "",
          email,
        },
      );

      await login(res.data);

      router.refresh();
    } catch {
      toast({
        error: true,
        message: "Google login failed",
      });
    }
  };

  const initializeOneTap = () => {
    if (!window.google) {
      return;
    }

    window.google.accounts.id.initialize({
      client_id: config.service.google.clientId,
      callback: handleCredentialResponse,
      auto_select: process.env.NODE_ENV == "production",
    });

    window.google.accounts.id.prompt();
  };

  useEffect(() => {
    if (window.google) initializeOneTap();
  }, []);

  return (
    <>
      <Script
        src="https://accounts.google.com/gsi/client"
        strategy="afterInteractive"
        onLoad={initializeOneTap}
      />
    </>
  );
}
